import { createElement } from 'react'

import { EditableFieldCell } from '@/components/data/editable-field-cell'
import type { FieldCellRenderer } from '@/components/data/field-cell-renderer'
import { describeFieldEdit } from '@/lib/field-edit'

/**
 * The FIT data view's field-editing renderer (`<FitDataView
 * renderFieldCell={renderEditableFieldCell}>`, see `field-cell-renderer.ts`).
 *
 * Only cells of the *current* state get an edit button, and only when
 * fit-core's `describeEditableField` says the field is editable --
 * everything else (the original-file view, developer/undocumented fields,
 * unknown message types, timestamps, ...) renders exactly as before, with
 * no affordance. The Records tab is excluded: it is a windowed table whose
 * rows are click/arrow-key targets for timeline sync; record fields remain
 * editable from "All messages".
 */
export const renderEditableFieldCell: FieldCellRenderer = (context, defaultContent) => {
  if (context.source !== 'current' || context.surface === 'records') return defaultContent
  const { messagesKey } = context
  if (messagesKey == null) return defaultContent
  const description = describeFieldEdit(context)
  if (!description.editable) return defaultContent
  return createElement(EditableFieldCell, {
    context,
    description,
    messagesKey,
    children: defaultContent,
  })
}
